
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/estate-agents/rental-lists-and-brochures",
      function () {
        return require("private-next-pages/products/estate-agents/rental-lists-and-brochures.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/estate-agents/rental-lists-and-brochures"])
      });
    }
  